import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import ConfirmationModal2 from '../common/ConfirmationModal2'
import { ReactComponent as WarningIcon } from '../../assets/images/common/icons/warning-icon.svg'

import classes from './DeleteConfirmationModal.module.scss'

const DeleteConfirmationModal = ({ show, title, message, proceedMessage, isLoading, onClose, onProceed }) => {
  const { t } = useTranslation()

  return (
    <ConfirmationModal2
      showModal={show}
      closeModal={onClose}
      onDeny={onClose}
      denyMessage={t('common.cancel')}
      onProceed={onProceed}
      proceedMessage={proceedMessage || t('common.delete')}
      isLoading={isLoading}
      icon={<WarningIcon aria-hidden='true' className={`${classes.warningIcon} align-self-center mb-2`} />}
      title={title}
      message={message}
    />
  )
}

DeleteConfirmationModal.propTypes = {
  show: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string,
  proceedMessage: PropTypes.string,
  isLoading: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onProceed: PropTypes.func.isRequired,
}

export default DeleteConfirmationModal
